import React, { useEffect, useRef, useState } from 'react';
import AppLayout from '../layout/AppLayout';
import SessionManager from '../auth/sessionmanager';
import Iframe from 'react-iframe';
import { greek_nodeRed, romanian_nodeRed, spanish_nodeRed } from '../data/urlData';
import decodeJWTtenant from '../services/decodeJWTtenant';

const IframeComponent = () => {
  const iframeRef = useRef(null);
  const [accessToken, setAccessToken] = useState(null);
  const [hasReloaded, setHasReloaded] = useState(false);
  const token = SessionManager.getToken?.();
  const tenant = decodeJWTtenant(token);
  let iframeUrl;

  if (tenant === 'tenant-es'){
    iframeUrl = `${spanish_nodeRed}`;
  } else if ( tenant === 'tenant-gr'){
    iframeUrl = `${greek_nodeRed}`;
  } else if (tenant === 'tenant-ro'){
    iframeUrl = `${romanian_nodeRed}`;
  }

  // Function to get cookie value by name
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

    // Function to set cookie
  const setCookie = (name, value, days = 1) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  };

   
  useEffect(() => {        

    if (token) {
      setAccessToken(token);
    }
  }, [token]);

  useEffect(() => {
  let lastHasSession = !!getCookie("KEYCLOAK_SESSION");

  const checkCookie = () => {
    const hasSession = !!getCookie("KEYCLOAK_SESSION");

    // Reload if cookie just appeared
    if (hasSession) {
      window.location.reload();     
    }

    lastHasSession = hasSession;
  };

  // Check every 2 seconds (adjust interval as needed)
  const interval = setInterval(checkCookie, 2000);

  return () => clearInterval(interval);
}, []);

  const handleIframeLoad = () => {
    if (accessToken && iframeRef.current) {
      iframeRef.current.contentWindow.postMessage(
        { token: accessToken },
         iframeUrl  
      );
    }
  };

  return (
    <AppLayout>
      <div style={{ width: '100%', height: '80vh' }}>
        <Iframe
          url={iframeUrl}
          width="100%"
          height="100%"
          id="secured-iframe"
          className=""
          display="block"
          position="relative"
          innerRef={iframeRef}
          onLoad={handleIframeLoad}
        />
      </div>
    </AppLayout>
  );
};

export default IframeComponent;